import { render, staticRenderFns } from "./product-type.vue?vue&type=template&id=3fde7a70&scoped=true"
import script from "./product-type.vue?vue&type=script&lang=js"
export * from "./product-type.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fde7a70",
  null
  
)

export default component.exports